import React from 'react';
import PropTypes from 'prop-types';

import { Station } from '../libs/networks'
import ChannelsTable from './Table/ChannelsTable';
import ChannelsTableGeomag from './Table/ChannelsTableGeomag';

import { useLanguageState } from '../contexts/LanguageProvider';

const ChannelsDetails = ({networkCode, station, fdsnws}) => {
  const [ lang ] = useLanguageState();
  return (
    <>
      <h2>{lang.channelsHistory}</h2>
        {lang.lang === 'fr' ? 
          <p>
            Vous trouverez ci-dessous un bref résumé de l'historique des canaux pour {networkCode}.{station.code}. {fdsnws && <span>Pour plus de détails, téléchargez les informations StationXML sur <a href={fdsnws}>{fdsnws}</a>.</span>} Les détails du schéma StationXML sont disponibles à l'adresse <a href="https://www.fdsn.org/xml/station/" target="blank">https://www.fdsn.org/xml/station/</a>.
        </p>
        :<p>
            Below is a brief summary of the channels history for {networkCode}.{station.code}. {fdsnws && <span>For more details, download the StationXML information from <a href={fdsnws}>{fdsnws}</a>.</span>} StationXML schema details can be found at <a href="https://www.fdsn.org/xml/station/" target="blank">https://www.fdsn.org/xml/station/</a>.
        </p>
        }
      {networkCode === 'C2'
        ? <ChannelsTableGeomag channels={station.channels} />
        : <ChannelsTable channels={station.channels} />
      }
    </>
  )
};


ChannelsDetails.propTypes = {
  /**
   * Network code of the selected station
   */
  networkCode: PropTypes.string.isRequired,
  /**
   * Station object with required channels information
   */
  station: PropTypes.instanceOf(Station).isRequired,
  /**
   * Render a feedback that the information can be downloaded at this link
   */
  fdsnws: PropTypes.string
};


ChannelsDetails.defaultProps = {
  fdsnws: null,
};


export default ChannelsDetails;